module.exports = __webpack_public_path__ + "img/tn-timeline-main-14.66b96e33.jpg";